import Axios, { type AxiosRequestConfig } from "axios";

import type { AuctionBidType, IPaginatedResponse } from "@utils/types";

export async function deleteBid(bidId: number) {
  const response = await Axios.delete(`/api/bids/${bidId}/`);
  return response.data;
}

export async function getByAuction(
  auctionId: number | string,
  config?: AxiosRequestConfig,
): Promise<IPaginatedResponse<AuctionBidType>> {
  const response = await Axios.get(`/api/auctions/${auctionId}/bids/received/`, config);
  return response.data;
}
